const documentTypeConst = {
    safeGaurdingPolicy: 'safeGaurdingPolicy',
    riskAssessment: 'riskAssessment',
    liabilityInsurance: 'liabilityInsurance'
};

export default {
    documentTypeConst
};
